/**
 =========================================================
 * Material Kit 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";
import "react-image-lightbox/style.css"; // Import the styles
import Lightbox from "react-image-lightbox"; // Import the Lightbox component

// Material Kit 2 React components
import { useState } from "react";
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";
import MKButton from "../../../components/MKButton";

import bgexample from "../../../assets/images/backgrounds/bg-example-hkh1.jpg";

function ModelCard({ model, action }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const handleImageClick = () => {
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };
  return (
    <Card>
      <MKBox position="relative" borderRadius="lg" mx={2}>
        {model.image !== "" ? (
          <MKBox
            component="img"
            src={model.image}
            alt={model.type}
            borderRadius="lg"
            width="100%"
            title={model.description}
            position="relative"
            zIndex={1}
            onClick={handleImageClick}
          />
        ) : (
          <MKBox
            component="img"
            src={bgexample}
            alt={model.type}
            borderRadius="lg"
            width="100%"
            position="relative"
            zIndex={1}
          />
        )}
        {lightboxOpen && (
          <Lightbox
            mainSrc={model.image}
            onCloseRequest={handleCloseLightbox} // Close the lightbox
          />
        )}
      </MKBox>
      <MKBox p={1} textAlign="center">
        <MKTypography display="inline" variant="h5" textTransform="capitalize" fontWeight="regular">
          {model.type}
        </MKTypography>
      </MKBox>
      <MKBox px={2}>
        <MKTypography
          variant="body2"
          color="text"
          title={model.description}
          sx={{
            width: 1,
            textOverflow: "ellipsis",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: { xl: "5" },
          }}
        >
          {model.description}
        </MKTypography>

        <MKBox sx={{ display: "block", width: 1 }}>
          {Object.entries(model.chips).map(([key, value]) => (
            <MKBox key={key} sx={{ display: "inline-block", pr: 2 }}>
              <MKBox sx={{ display: "flex", alignItems: "center" }}>
                <MKBox sx={{ display: "inline" }}>
                  <MKTypography
                    variant="body2"
                    fontWeight="bold"
                    textTransform="capitalize"
                    sx={{ display: "inline" }}
                  >
                    {`${key}:`}
                  </MKTypography>
                </MKBox>
                <MKTypography
                  variant="body2"
                  color="text"
                  sx={{ flexWrap: "wrap", display: "inline", ml: 1 }}
                >
                  {value.replace(/~/g, " - ").replace(/,/g, " , ")}
                </MKTypography>
              </MKBox>
            </MKBox>
          ))}
        </MKBox>
      </MKBox>
      <MKBox textAlign="center" p={1}>
        {action.type === "external" ? (
          <MKButton
            component={MuiLink}
            href={action.route}
            target="_blank"
            rel="noreferrer"
            size="medium"
            color={action.color ? action.color : "dark"}
          >
            {action.label}
          </MKButton>
        ) : (
          <MKButton
            component={Link}
            to={action.route}
            size="medium"
            color={action.color ? action.color : "dark"}
          >
            {action.label}
          </MKButton>
        )}
      </MKBox>
    </Card>
  );
}

// Typechecking props for the CenteredBlogCard
ModelCard.propTypes = {
  model: PropTypes.objectOf(PropTypes.any).isRequired,
  action: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default ModelCard;
